const IMPOSITION_STATUS_CANCELED = 'IMPOSITION_STATUS_CANCELED';
const IMPOSITION_STATUS_EXPIRED = 'IMPOSITION_STATUS_EXPIRED';
const IMPOSITION_STATUS_VALID = 'IMPOSITION_STATUS_VALID';

const getImpositionStatus = (immImposition, currentServiceDate) => {
    if (!immImposition.get('amount')) return IMPOSITION_STATUS_CANCELED;
    if (new Date (immImposition.get('expirationDate')) <= new Date(currentServiceDate)) return IMPOSITION_STATUS_EXPIRED;

    return IMPOSITION_STATUS_VALID;
}

const impositionTextKeyfromStatus = (status) => {
    let textKey = 'impositionRow-valid';
    switch (status) {
        case IMPOSITION_STATUS_CANCELED:
            textKey = 'impositionRow-canceled';
            break;
        case IMPOSITION_STATUS_EXPIRED:
            textKey = 'impositionRow-expired';
            break;
    }
    return textKey;
}

module.exports = {
    IMPOSITION_STATUS_CANCELED,
    IMPOSITION_STATUS_EXPIRED,
    IMPOSITION_STATUS_VALID,
    getImpositionStatus,
    impositionTextKeyfromStatus,
}
